import { app } from '../app';

app.directive('autofocus', autofocus);

/** @ngInject */
function autofocus() {
    return {
        restrict: 'A',
        link: ($scope, $element) => $element[0].focus(),
    };
}



// WEBPACK FOOTER //
// ./src/portal/directives/auto-focus.directive.js